import { getClearWordFromTranscript } from '../../common/Common';

// Adds a bunch of newSpeakersNames to the given speakersArray
// if they don't exist already.
export const addSpeakersToSpeakerArray = (speakersArray, newSpeakersNames) => {
  newSpeakersNames.forEach((name) => {
    if (!speakersArray.map(s => (s.toLowerCase())).includes(name.toLowerCase())) {
      speakersArray.push(name);
    }
  });
  return speakersArray;
};

export const parseKeywordsArray = (keywordsArray) => {
  let speakers = [];
  const keywords = keywordsArray.map((keyword) => {
    speakers = addSpeakersToSpeakerArray(speakers, Object.keys(keyword.t));
    // Hmmm... This looks totally wrong, but not sure what we're meant to be doing
    // will need to come back and check as it looks like we're overwriting the
    // times property when a new one is found.
    const times = {};
    Object.keys(keyword.t).forEach((speakerName) => {
      times[speakerName.toLowerCase()] = keyword.t[speakerName];
    });
    return {
      ...keyword,
      t: times,
      score: +(keyword.score),
    };
  });
  return { keywords, speakers };
};

export const parseTopicsArray = (topicsArray) => {
  let speakers = [];
  const topics = topicsArray.map((topic) => {
    const { keywords, speakers: keywordSpeakers } = parseKeywordsArray(topic.keywords);
    speakers = addSpeakersToSpeakerArray(speakers, keywordSpeakers);
    return {
      ...topic,
      score: +(topic.score),
      keywords,
    };
  });

  return { topics, speakers };
};

export const parseWordsArray = (wordArray) => {
  const transcriptSpeakers = [];
  let speakers = [];
  const words = wordArray.map((word) => {
    if (word.m && word.m === 'turn') {
      const speakerName = getClearWordFromTranscript(word.w);
      speakers = addSpeakersToSpeakerArray(speakers, [speakerName]);
      transcriptSpeakers.push({ start: word.s, name: speakerName.toLowerCase() });
    }
    return {
      ...word,
    };
  });

  return { words, speakers, transcriptSpeakers };
};

export const parseClassifiersArray = classifiers => (
  // eg: {
  //   "classifierId":"cc3ab1b0-640c-4928-85a0-1c8ff47447d7",
  //   "classifierName":"No_answer",
  //   "classifierDisplayName":"No_answer",
  //   "classifierType":"binary",
  //   "predictedClassLabel":"Call_Answered",
  //   "predictionScore":0.0018164473968978526,
  //   "predictedClass":0
  // }
  classifiers.map(classifier => ({
    id: classifier.classifierId,
    name: classifier.classifierDisplayName || classifier.classifierName || classifier.classifierId,
    type: classifier.classifierType,
    version: classifier.classifierVersion,
    label: classifier.predictedClassLabel,
    class: parseInt(classifier.predictedClass, 10),
  }))
);

export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const getExtensionFromContentType = (contentType) => {
  const mimeTypes = {
    "audio/mpeg": ".mp3",
    "audio/wav": ".wav",
    "audio/ogg": ".ogg",
    "audio/aac": ".aac",
    "audio/x-wav": ".wav",
    // Add more content types and their corresponding extensions here as needed
  };
  return mimeTypes[contentType] || '';
}

export const downloadMedia = async (url, filename, contentType, cb) => {
  try {
    const extension = getExtensionFromContentType(contentType || "audio/mpeg");
    const hasExtension = new RegExp(`${extension}$`, 'i').test(filename);
    const finalFilename = hasExtension ? filename : `${filename}${extension}`;
    const response = await fetch(url);
    // Check if response is ok (status in the range 200-299)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = finalFilename || `media${extension}`;
    // Append to body
    document.body.appendChild(link);
    // Start download
    link.click();
    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
    cb({ success: true });
  } catch (error) {
    console.error('Download failed:', error);
    cb({ success: false, error });
  }
};